import { render, staticRenderFns } from "./LayerContextMenu.vue?vue&type=template&id=5363a6cd&scoped=true"
import script from "./LayerContextMenu.vue?vue&type=script&lang=js"
export * from "./LayerContextMenu.vue?vue&type=script&lang=js"
import style0 from "./LayerContextMenu.vue?vue&type=style&index=0&id=5363a6cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5363a6cd",
  null
  
)

export default component.exports